import React from 'react';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import styles from './OldPayerP2P.css';

export default function OldPayerP2P(){
const codestyle={backgroundColor: 'lightgray', overflowX: 'auto'};
const fhirBase = process.env.REACT_APP_EDUCATIONAL_MATERIAL_URL + 'patientAccess/api/R4';
const tokenUrl = 'https://iam.iox.dev.sddss.apps.conduent.com/am/oauth2/iox/access_token';

const singleMatchBody={
  "resourceType": "Parameters",
  "parameter": [
    {
      "name": "MemberPatient",
      "resource": {
        "resourceType": "Patient",
        "name": [{ "family": "5482LNAME", "given": ["5482FNAME"] }],
        "gender": "female",
        "birthDate": "1960-01-01"
      }
    },
    {
      "name": "CoverageToMatch",
      "resource": {
        "resourceType": "Coverage",
        "status": "active",
        "identifier": [{
          "type": {
            "coding": [{
              "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
              "code": "MB"
            }]
          },
          "value": "202818102"
        }]
      }
    },
    {
      "name": "Consent",
      "resource": {
        "resourceType": "Consent",
        "status": "active",
        "policy": [{
          "uri": "http://hl7.org/fhir/us/davinci-hrex/StructureDefinition-hrex-consent.html#regular"
        }],
        "provision": {
          "type": "permit",
          "period": { "start": "2026-01-01", "end": "2027-12-31" }
        }
      }
    }
  ]
};

const bulkMatchConsent={
  "resourceType": "Consent",
  "status": "active",
  "policy": [{
    "uri": "http://hl7.org/fhir/us/davinci-hrex/StructureDefinition-hrex-consent.html#regular"
  }],
  "provision": {
    "type": "permit",
    "period": { "start": "2026-01-01", "end": "2027-12-31" }
  }
};

const bulkMatchTwoMemberBody={
  "resourceType": "Parameters",
  "parameter": [
    {
      "name": "MemberBundle",
      "part": [
        {
          "name": "MemberPatient",
          "resource": {
            "resourceType": "Patient",
            "name": [{ "family": "5482LNAME", "given": ["5482FNAME"] }],
            "gender": "female",
            "birthDate": "1960-01-01"
          }
        },
        {
          "name": "CoverageToMatch",
          "resource": {
            "resourceType": "Coverage",
            "status": "active",
            "identifier": [{
              "type": {
                "coding": [{
                  "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                  "code": "MB"
                }]
              },
              "value": "202818102"
            }]
          }
        },
        { "name": "Consent", "resource": bulkMatchConsent }
      ]
    },
    {
      "name": "MemberBundle",
      "part": [
        {
          "name": "MemberPatient",
          "resource": {
            "resourceType": "Patient",
            "name": [{ "family": "54823LNAME", "given": ["5482FNAME"] }],
            "gender": "female",
            "birthDate": "1960-01-01"
          }
        },
        {
          "name": "CoverageToMatch",
          "resource": {
            "resourceType": "Coverage",
            "status": "active",
            "identifier": [{
              "type": {
                "coding": [{
                  "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                  "code": "MB"
                }]
              },
              "value": "402818102"
            }]
          }
        },
        { "name": "Consent", "resource": bulkMatchConsent }
      ]
    }
  ]
};

return (
<div className="container">
<Card className="card-background"> <Card.Body>
<blockquote className="blockquote mb-0">
<h1 className="text-header">Payer-to-Payer (IOX as old Payer)</h1><br></br>
<p>When IOX is the responding (old) payer. A new payer that already collected the member&apos;s opt-in calls these Patient Access FHIR APIs to match the member and export prior claims and USCDI clinical data. This follows HRex <code>$member-match</code> and PDex / CMS-0057 <code>$bulk-member-match</code> plus Bulk Data Access export.</p>
<p>The new payer does not send IOX Patient or Coverage ids. Send enrollment demographics, the old-payer member number (MB), and the FHIR Consent collected from the member.</p>
</blockquote> </Card.Body>
</Card>
<br/>
<hr className="horizontal-rule"></hr>
<br/>

<Card className="card-background">
<Card.Body>
<h4 className="OldPayerP2P-heading">Base URL</h4>
<div>
<codeblock className="accesstoken-code"> URL</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">{fhirBase}</codeblock>
</div>
</Card.Body>
<Card.Body>
<h4 className="OldPayerP2P-heading">Access Token</h4>
<p>Use the existing IAM client-credentials token for the registered payer application. Request scope <code>openid profile system/*.read</code>.</p>
<div>
<codeblock className="accesstoken-code"> POST</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">{tokenUrl}</codeblock>
</div>
<br/>
<Table striped bordered hover>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/x-www-form-urlencoded</td>
</tr>
<tr>
<td>Authorization</td>
<td>Basic base64(client_id:client_secret)</td>
</tr>
</tbody>
</Table>
<h4 className="OldPayerP2P-heading">Body</h4>
<Table striped bordered hover>
<tbody>
<tr>
<td>grant_type</td>
<td>client_credentials</td>
</tr>
<tr>
<td>scope</td>
<td>openid profile system/*.read</td>
</tr>
</tbody>
</Table>
<h4 className="OldPayerP2P-heading">Sample Request</h4>
<div style={codestyle}>curl --location --request POST {tokenUrl} \<br/>
--header &apos;Authorization: Basic base64(client_id:client_secret)&apos; \<br/>
--header &apos;Content-Type: application/x-www-form-urlencoded&apos; \<br/>
--data-urlencode &apos;grant_type=client_credentials&apos; \<br/>
--data-urlencode &apos;scope=openid profilesystem/*.read&apos;
</div>
<p>Use the returned access token as <code>Authorization: Bearer ACCESS_TOKEN</code> on every FHIR call below. The same client_id that ran match must be used for status, export, and file download.</p>
</Card.Body>
</Card>
<br/>
<hr className="horizontal-rule"></hr>
<br/>

<Card className="card-background">
<Card.Body>
<h4 className="OldPayerP2P-heading">Which match API to call</h4>
<Table striped bordered hover>
<thead>
<tr>
<th>Use</th>
<th>Operation</th>
<th>When</th>
</tr>
</thead>
<tbody>
<tr>
<td>Single member match</td>
<td>POST /R4/Patient/$member-match</td>
<td>One person. Synchronous. No unique match returns 422.</td>
</tr>
<tr>
<td>Bulk member match</td>
<td>POST /R4/Group/$bulk-member-match</td>
<td>One or many members. Asynchronous. Required for CMS-0057 bulk exchange. Prefer: respond-async is required.</td>
</tr>
</tbody>
</Table>
<p>After a successful match, call the same <code>Group/&#123;id&#125;/$export</code>. Download every URL in <code>output[]</code>.</p>
<p>CARIN types: Patient, Coverage, ExplanationOfBenefit.</p>
<p>Clinical types when present: AllergyIntolerance, CarePlan, CareTeam, Condition, Device, DiagnosticReport, DocumentReference, Encounter, Goal, Immunization, MedicationDispense, MedicationRequest, Observation, Procedure.</p>
<h4 className="OldPayerP2P-heading">Five-year lookback (CMS-0057)</h4>
<ul className="OldPayerP2P-list">
<li>ExplanationOfBenefit: date of service within the last five years .</li>
<li>Clinical resources: date of service within the last five years.</li>
<li>Patient and Coverage are not limited to five years.</li>
</ul>
</Card.Body>
</Card>
<br/>
<hr className="horizontal-rule"></hr>
<br/>

<Card className="card-background">
<Card.Body>
<h1 className="text-header">Single member match</h1>
<ol className="OldPayerP2P-list">
<li>POST /R4/Patient/$member-match — copy groupId from the response</li>
<li>GET /R4/Group/&#123;groupId&#125;/$export — copy Content-Location</li>
<li>GET /R4/$export/job/&#123;jobId&#125; — poll until 200</li>
<li>GET /R4/$export/file/&#123;fileId&#125;.ndjson — download each output[] file (Patient, Coverage, EOB, and clinical types when present)</li>
</ol>
<h4 className="OldPayerP2P-heading">1. Member Match Kickoff</h4>
<div>
<codeblock className="accesstoken-code"> POST</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">{fhirBase}/Patient/$member-match</codeblock>
</div>
<br/>
<Table striped bordered hover>
<tbody>
<tr>
<td>Authorization</td>
<td>Bearer ACCESS_TOKEN</td>
</tr>
<tr>
<td>Content-Type</td>
<td>application/fhir+json</td>
</tr>
<tr>
<td>Accept</td>
<td>application/fhir+json</td>
</tr>
</tbody>
</Table>
<p>Prefer is not used on single-member match. Send MB (member number), not the IOX Patient persist id. Consent is required: status=active, HRex #regular or #sensitive, provision.type=permit, period covering now.</p>
<h4 className="OldPayerP2P-heading">Sample Body</h4>
<pre style={codestyle}>
<code className="prettyprint">
{JSON.stringify(singleMatchBody,null,'  ')}
</code>
</pre>
<p>Success is 200 with MemberIdentifier, MemberId (Patient/&#123;id&#125;), and groupId. Zero or many matches return 422 No unique member match. Use groupId on the export call. Do not POST to a job URL after this operation.</p>
<h4 className="OldPayerP2P-heading">2. Export Kickoff</h4>
<div>
<codeblock className="accesstoken-code"> GET</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">{fhirBase}/Group/&#123;groupId&#125;/$export</codeblock>
</div>
<p>No body. Expect 202. Copy Content-Location. UI DNS includes patientAccess/api; FHIR IP does not.</p>
<h4 className="OldPayerP2P-heading">3. Export Status</h4>
<div>
<codeblock className="accesstoken-code"> GET</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">{fhirBase}/$export/job/&#123;jobId&#125;</codeblock>
</div>
<p>No body. Poll until 200. Copy each URL in output[] (CARIN and clinical types).</p>
<h4 className="OldPayerP2P-heading">4. Export File Download</h4>
<div>
<codeblock className="accesstoken-code"> GET</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">{fhirBase}/$export/file/&#123;fileId&#125;.ndjson</codeblock>
</div>
<Table striped bordered hover>
<tbody>
<tr>
<td>Authorization</td>
<td>Bearer ACCESS_TOKEN</td>
</tr>
<tr>
<td>Accept</td>
<td>application/fhir+ndjson</td>
</tr>
</tbody>
</Table>
</Card.Body>
</Card>
<br/>
<hr className="horizontal-rule"></hr>
<br/>

<Card className="card-background">
<Card.Body>
<h1 className="text-header">Bulk member match</h1>
<p>Use this path for multiple members and for a single member when following CMS-0057 bulk exchange. One MemberBundle is valid. Do not call Patient/$bulk-member-match.</p>
<ol className="OldPayerP2P-list">
<li>POST /R4/Group/$bulk-member-match — 202 + Content-Location</li>
<li>GET /R4/$bulk-member-match/job/&#123;bulkMatchJobId&#125; — poll until 200; copy matchedGroupId</li>
<li>GET /R4/Group/&#123;matchedGroupId&#125;/$export</li>
<li>GET /R4/$export/job/&#123;exportJobId&#125;</li>
<li>GET /R4/$export/file/&#123;fileId&#125;.ndjson — each output[] type, including clinical when present</li>
</ol>
<h4 className="OldPayerP2P-heading">1. P2P Bulk Member Match – Kickoff</h4>
<div>
<codeblock className="accesstoken-code"> POST</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">{fhirBase}/Group/$bulk-member-match</codeblock>
</div>
<br/>
<Table striped bordered hover>
<tbody>
<tr>
<td>Authorization</td>
<td>Bearer ACCESS_TOKEN</td>
</tr>
<tr>
<td>Prefer</td>
<td>respond-async</td>
</tr>
<tr>
<td>Content-Type</td>
<td>application/fhir+json</td>
</tr>
<tr>
<td>Accept</td>
<td>application/fhir+json</td>
</tr>
</tbody>
</Table>
<p>Prefer: respond-async is required. Missing header returns 400. Body is Parameters with one or more MemberBundle parts. Each bundle has MemberPatient, CoverageToMatch, and Consent (same resources as single match). Optional CoverageToLink. Add another parameter named MemberBundle for each extra member.</p>
<h4 className="OldPayerP2P-heading">Sample Body (two members)</h4>
<pre style={codestyle}>
<code className="prettyprint">
{JSON.stringify(bulkMatchTwoMemberBody,null,'  ')}
</code>
</pre>
<h4 className="OldPayerP2P-heading">Sample Request</h4>
<div style={codestyle}>curl --location --request POST {fhirBase}/Group/$bulk-member-match \<br/>
--header &apos;Authorization: Bearer ACCESS_TOKEN&apos; \<br/>
--header &apos;Prefer: respond-async&apos; \<br/>
--header &apos;Content-Type: application/fhir+json&apos; \<br/>
--header &apos;Accept: application/fhir+json&apos; \<br/>
--data-raw &apos;{JSON.stringify(bulkMatchTwoMemberBody)}&apos;
</div>
<p>Expect 202. Copy Content-Location, for example {fhirBase}/$bulk-member-match/job/&#123;bulkMatchJobId&#125;. Do not export using this job id.</p>
<h4 className="OldPayerP2P-heading">2. P2P Bulk Member Match – Status</h4>
<div>
<codeblock className="accesstoken-code"> GET</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">{fhirBase}/$bulk-member-match/job/&#123;bulkMatchJobId&#125;</codeblock>
</div>
<Table striped bordered hover>
<tbody>
<tr>
<td>Authorization</td>
<td>Bearer ACCESS_TOKEN</td>
</tr>
<tr>
<td>Accept</td>
<td>application/json</td>
</tr>
</tbody>
</Table>
<p>GET only. No body and no Prefer. POST to this URL is not supported. Poll while status is Accepted or InProgress (HTTP 202). When HTTP 200, copy matchedGroupId. Non-matched and consent-constrained group ids may also be present. Export only the matched group.</p>
<h4 className="OldPayerP2P-heading">3. P2P Bulk Export – Kickoff</h4>
<div>
<codeblock className="accesstoken-code"> GET</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">{fhirBase}/Group/&#123;matchedGroupId&#125;/$export</codeblock>
</div>
<p>No body. Prefer is not required. Expect 202. Copy Content-Location. On the UI host that header is {fhirBase}/$export/job/&#123;jobId&#125;. On the FHIR IP it is /R4/$export/job/&#123;jobId&#125;.</p>
<h4 className="OldPayerP2P-heading">4. P2P Bulk Export – Status</h4>
<div>
<codeblock className="accesstoken-code"> GET</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">{fhirBase}/$export/job/&#123;exportJobId&#125;</codeblock>
</div>
<p>GET only. Poll until 200. Copy every output[] file URL (CARIN and clinical types).</p>
<h4 className="OldPayerP2P-heading">5. P2P Bulk Export – Download NDJSON</h4>
<div>
<codeblock className="accesstoken-code"> GET</codeblock>
<span>&nbsp;</span><span>&nbsp;</span>
<codeblock className="accesstoken-code">{fhirBase}/$export/file/&#123;fileId&#125;.ndjson</codeblock>
</div>
<Table striped bordered hover>
<tbody>
<tr>
<td>Authorization</td>
<td>Bearer ACCESS_TOKEN</td>
</tr>
<tr>
<td>Accept</td>
<td>application/fhir+ndjson</td>
</tr>
</tbody>
</Table>
</Card.Body>
</Card>
<br/>
<hr className="horizontal-rule"></hr>
<br/>

<Card className="card-background">
<Card.Body>
<h4 className="OldPayerP2P-heading">Bulk match outcomes</h4>
<Table striped bordered hover>
<thead>
<tr>
<th>Group</th>
<th>When</th>
</tr>
</thead>
<tbody>
<tr>
<td>matchedGroupId</td>
<td>Unique match and valid Consent. Always created (may be empty). This is the group to export.</td>
</tr>
<tr>
<td>nonMatchedGroupId</td>
<td>No unique match, missing MB, or missing MemberPatient / CoverageToMatch.</td>
</tr>
<tr>
<td>consentConstrainedGroupId</td>
<td>Unique match, but Consent cannot be complied with.</td>
</tr>
</tbody>
</Table>
<p>A failed member does not 422 the whole bulk batch. Missing MemberBundle at kickoff returns 422.</p>
<h4 className="OldPayerP2P-heading">Consent</h4>
<ul className="OldPayerP2P-list">
<li>The new payer collects opt-in and sends Consent on $member-match and on each $bulk-member-match MemberBundle.</li>
<li>Export re-checks stored Consent (active, permit, period covering now). That is not a token-scope check.</li>
<li>Request scope for these APIs is openid profile system/*.read.</li>
</ul>
<h4 className="OldPayerP2P-heading">Common errors</h4>
<Table striped bordered hover>
<thead>
<tr>
<th>What was sent</th>
<th>Result</th>
<th>Correct call</th>
</tr>
</thead>
<tbody>
<tr>
<td>POST /R4/Patient/$bulk-member-match</td>
<td>not-supported</td>
<td>POST /R4/Group/$bulk-member-match</td>
</tr>
<tr>
<td>Missing Prefer: respond-async on bulk match</td>
<td>400</td>
<td>Header Prefer: respond-async</td>
</tr>
<tr>
<td>POST /$bulk-member-match/job/&#123;id&#125;</td>
<td>not-supported</td>
<td>GET /$bulk-member-match/job/&#123;id&#125;</td>
</tr>
<tr>
<td>GET /R4/Group/&#123;bulkMatchJobId&#125;/$export</td>
<td>Group not found</td>
<td>GET /R4/Group/&#123;matchedGroupId&#125;/$export</td>
</tr>
</tbody>
</Table>
</Card.Body>
</Card>
</div>
);
}
